import storage from 'src/util/storage';

export default {
	init: false,
	accessToken: storage.get('auth.accessToken'),
	currentUser: storage.get('auth.currentUser'),
};
